import axios from "axios"
import { POSTS_LIMIT } from "@/constants/postsFeed.js"

export const followedHashtags = (page) =>
  axios.get("/api/v2/followed_hashtags", {
    params: {
      page
    }
  })

export const posts = function ({ key, cursor }) {
  return axios.get(`/api/v2/hashtags/${key}/posts`, {
    params: {
      cursor,
      limit: POSTS_LIMIT
    }
  })
}

export const search = function (hashtag) {
  return axios.get("/api/v2/hashtags", {
    params: {
      text: hashtag
    }
  })
}
